export default IconFoldUp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-fold-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 13v-8l-3 3m6 0l-3 -3" />
  <path d="M9 17l1 0" />
  <path d="M14 17l1 0" />
  <path d="M19 17l1 0" />
  <path d="M4 17l1 0" />
</svg>`;